import { useQuery } from '@apollo/client';
import React from 'react';
import { GET_USER_INFO } from '../api/queries/session';
import Loading from './Loading';
import ErrorToast from './ErrorToast';
import RouterWrapper from './RouterWrapper';

function UserContainer () {
    const { data, error, loading } = useQuery(GET_USER_INFO, {
        fetchPolicy: 'cache-and-network'
    });

    const remote_control = data && data.remote_control ? data.remote_control : {};
    const organizations = remote_control.organizations;

    if (loading) return <Loading />;

    if (error) {
        if (error.networkError?.result?.errors?.[0].message === 'Context creation failed: User must be RemoteControl') {
            window.oktaAuth.signOut();
            return <ErrorToast message='User Not Allowed' severity='error' />;
        }

        return <ErrorToast message={error.message} severity='error' />;
    }

    if (!loading && (organizations && organizations.length === 0)) {
        return <ErrorToast message='User does not have access to any org.' severity='error' />;
    }

    return (
        <RouterWrapper remote_control={remote_control} />
    );
}

export default UserContainer;
